import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import ReactGA from "react-ga4";
import TagManager from 'react-gtm-module'

import { Helmet } from "react-helmet";
import Navigation from "./components/common/navigation";

import Homepage from "./pages/homepage.jsx";
import Notfound from "./pages/404.jsx";
import Articles from "./pages/articles.jsx";
import Services from "./pages/services.jsx";
import About from "./pages/about.jsx";
import Contact from "./pages/contact.jsx";
import Article from "./pages/Article.jsx";

import { TRACKING_ID, GTM_ID } from "./data/tracking";
import "./app.css";

function App() {
	useEffect(() => {
        if (TRACKING_ID) {
            ReactGA.initialize(TRACKING_ID);
        }
        if (GTM_ID) {
            TagManager.initialize({ gtmId: GTM_ID });
        }
	}, []);

	return (
		<div className="App">
			<Helmet>
				<title>Pasmo The Beauty Lab | Expert Hair Salon in Falls Church, VA</title>
				<meta name="description" content="Premier hair salon in Falls Church specializing in balayage, Asian hair, color correction, highlights, brazilian blowout and precision cuts. Book your transformation today!" />
				<meta name="keywords" content="balayage Falls Church, balayage Falls Church VA, hair salon Falls Church, hair salon Falls Church VA, hair salon Northern Virginia, balayage specialist NoVA, hair color expert, Asian hair specialist, keratin treatment Falls Church, blonde specialist VA, hair transformation DMV, best hair colorist, Japanese hair straightening, 
					Korean hair salon, highlights specialist, color correction expert, bridal hair stylist, 
					luxury hair salon, modern hair salon, precision haircuts, dimensional color, 
					hair gloss treatment, scalp treatment, olaplex treatment, hair toner specialist, 
					hair extensions NoVA, babylights expert, root shadow specialist, lived-in color expert, 
					Fairfax hair salon, Arlington stylist, Alexandria colorist, Tysons hair specialist, 
					McLean beauty salon, Vienna hair expert, Reston hair artist, Great Falls stylist, 
					Mosaic District salon, Merrifield hair studio, Seven Corners beauty" />
                {/* Per-page canonical links are set in each route component */}
                <meta property="og:site_name" content="Pasmo The Beauty Lab" />
                <meta property="og:locale" content="en_US" />
			</Helmet>

			<Navigation />
			<Routes>
				<Route path="/" element={<Homepage />} />
				<Route path="/articles" element={<Articles />} />
				<Route path="/services" element={<Services />} />
				<Route path="/about" element={<About />} />
				<Route path="/contact" element={<Contact />} />
				<Route path="/articles/:shortName" element={<Article />} />
				<Route path="*" element={<Notfound />} />
			</Routes>
		</div>
	);
}

export default App;
